import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import {
  TenantMakesCreateDto,
  TenantModelsCreateDto,
  TenantMakesUpdateDto,
  TenantModelsUpdateDto,
  TenantMakesDeleteDto,
  TenantModelsDeleteDto,
} from '@rabbit/nest/api';
import { DTTenant_Public } from '@rabbit/data/types';

// Get makes and models for a tenant
export const nestApiGetMakesModels = FBF_CloudCallable<
  { tenantLink: string },
  DTTenant_Public
>(`api/tenant/get-makes-models/:tenantLink|GET`);

// Create makes for a tenant
export const nestApiCreateTenantMakes = FBF_CloudCallable<
  TenantMakesCreateDto,
  DTTenant_Public
>('api/tenant/makes|POST');

// Create models for a tenant
export const nestApiCreateTenantModels = FBF_CloudCallable<
  TenantModelsCreateDto,
  DTTenant_Public
>('api/tenant/models|POST');

// Update a make for a tenant
export const nestApiUpdateTenantMakes = FBF_CloudCallable<
  TenantMakesUpdateDto,
  DTTenant_Public
>('api/tenant/makes|PUT');

// Update a model for a tenant
export const nestApiUpdateTenantModels = FBF_CloudCallable<
  TenantModelsUpdateDto,
  DTTenant_Public
>('api/tenant/models|PUT');

// Delete a specific make for a tenant
export const nestApiDeleteTenantMakes = FBF_CloudCallable<
  TenantMakesDeleteDto,
  DTTenant_Public
>('api/tenant/makes|DELETE');

// Delete a specific model for a tenant
export const nestApiDeleteTenantModels = FBF_CloudCallable<
  TenantModelsDeleteDto,
  DTTenant_Public
>('api/tenant/models|DELETE'); 